export default __webpack_public_path__ + "static/media/form-icon.d34e24b6.svg";